import { useParams } from "@tanstack/react-router";
import { trpcClient } from "@/lib/trpc";
import { ToolingItemForm } from "./ToolingItemForm";
import { Skeleton } from "@/components/ui/skeleton";
import { useQuery } from "@tanstack/react-query";

export default function ToolingItemEditPage() {
  const { id } = useParams({ strict: false });
  const { data: item, isLoading } = useQuery({
    queryKey: ["tooling", id],
    queryFn: () => trpcClient.tooling.getItem.query({ id: id as string }),
  });

  if (isLoading) {
    return (
      <div className="w-full px-4 sm:px-6 py-4 space-y-6">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-96 w-full" />
      </div>
    );
  }

  if (!item) {
    return (
      <div className="w-full px-4 sm:px-6 py-4">
        <p className="text-destructive">Không tìm thấy Công cụ / Dụng cụ.</p>
      </div>
    );
  }

  return (
    <div className="w-full px-4 sm:px-6 py-4">
      <ToolingItemForm initialData={item} isEdit />
    </div>
  );
}
